export default __webpack_public_path__ + "static/about-tech4good-sw-c68625808eacd103fa4b2ef2d6582fb7.png";